import React, { useState } from 'react';
import { Save, Upload } from 'lucide-react';
import { Card, CardBody, Button, Input, TextArea, toast } from '../../components/common';
import './Settings.css';

export default function CompanySettings() {
    const [form, setForm] = useState({
        companyName: '',
        legalName: '',
        taxId: '',
        address: '',
        city: '',
        postalCode: '',
        country: '',
        phone: '',
        email: '',
        website: ''
    });
    const [saving, setSaving] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setSaving(true);
        // Simulate API call
        await new Promise(r => setTimeout(r, 1000));
        toast.success('Company settings saved');
        setSaving(false);
    };

    return (
        <Card>
            <CardBody>
                <div className="settings-form">
                    <div className="settings-section">
                        <h3>Company Information</h3>
                        <div className="settings-grid">
                            <Input
                                name="companyName"
                                label="Company Name"
                                value={form.companyName}
                                onChange={handleChange}
                            />
                            <Input
                                name="legalName"
                                label="Legal Name"
                                value={form.legalName}
                                onChange={handleChange}
                            />
                            <Input
                                name="taxId"
                                label="Tax ID / NPWP"
                                value={form.taxId}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="settings-section">
                        <h3>Contact Information</h3>
                        <div className="settings-grid">
                            <Input
                                name="phone"
                                label="Phone"
                                value={form.phone}
                                onChange={handleChange}
                            />
                            <Input
                                name="email"
                                label="Email"
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                            />
                            <Input
                                name="website"
                                label="Website"
                                value={form.website}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="settings-section">
                        <h3>Address</h3>
                        <TextArea
                            name="address"
                            label="Street Address"
                            value={form.address}
                            onChange={handleChange}
                            rows={2}
                        />
                        <div className="settings-grid" style={{ marginTop: '1rem' }}>
                            <Input
                                name="city"
                                label="City"
                                value={form.city}
                                onChange={handleChange}
                            />
                            <Input
                                name="postalCode"
                                label="Postal Code"
                                value={form.postalCode}
                                onChange={handleChange}
                            />
                            <Input
                                name="country"
                                label="Country"
                                value={form.country}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="settings-actions">
                        <Button icon={Save} onClick={handleSave} loading={saving}>
                            Save Changes
                        </Button>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
}
